import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const fullImageWithHeadingSchema = Joi.object({
  type: Joi.string().valid('fullImageWithHeading').required(),
  code: Joi.string().allow('', null).required(),
  backgroundImage: mediaUrlSchema.allow(null).required(),
  video: mediaUrlSchema.allow(null).required(),
  thumbnail: Joi.object(imageWithMetaDataSchema).allow(null, ''),
  title: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  buttonText: Joi.string().allow('', null).required(),
  buttonUrl: Joi.string().allow('', null),
  imagesWithBlur: imagesWithBlurSchema.allow('', null),
  thumbnailsWithBlur: imagesWithBlurSchema.allow('', null),
  variant: Joi.string().allow('', null),
  variantAlignContent: Joi.string().allow('', null),
  contentWidth: Joi.string().allow('', null)
}).unknown(true);
export default fullImageWithHeadingSchema;